import { render, staticRenderFns } from "./trafficDistribution.vue?vue&type=template&id=88a95e7a&scoped=true&"
import script from "./trafficDistribution.vue?vue&type=script&lang=js&"
export * from "./trafficDistribution.vue?vue&type=script&lang=js&"
import style0 from "./trafficDistribution.vue?vue&type=style&index=0&id=88a95e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a95e7a",
  null
  
)

export default component.exports